export default function partnerAuth({next, auth}){
    const adminRoles = ['super-admin', 'developer','admin', 'partner']

        if(! adminRoles.includes(auth.role)) {
            return next({
                name: '403'
            });
        }

    return next();
}